import { isEmpty } from "lodash";
import { returnQueryStringParametersInObject } from "./returnQueryStringParametersInObject";

export const formStateWithQueryParams = (state) => {
  const queryParams = returnQueryStringParametersInObject(window.location.href);
  return isEmpty(queryParams) ? state : { ...state, formFields: queryParams };
};
